import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const packingSlip = {
  id: 'packing-slip',

  getDocumentRequestNotificationProps: (docCount, selectedPrinterName) => ({
    title: <FormattedMessage {...messages.printingPackingSlipTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.sentToPrinter} values={{ selectedPrinterName }} />,
  }),
};
